import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      fontSize: 18,
      lineHeight: 1.2,
      fontWeight: 'bold',
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
  }),
);
export default useStyles;
